import React, { useState, useEffect, useRef } from "react";
import { Col, FormGroup, Input, Label, Button, Row, InputGroup, InputGroupText } from "reactstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import Tooltip from "react-tooltip-lite";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import useAxios from 'hooks/useAxios';
import { dateFormate } from 'utils/columns';
import { toast } from "react-toastify";
import { json } from "d3";
import save from "assets/icon/save.svg";
import AddWholeSaler from "assets/icon/AddWholeSaler.svg"
import HoverImage from "react-hover-image/build";
import Addicon from "assets/icon/EditConfig.svg";
import Arrow from 'assets/icon/LeftChevron.svg'
import Cancel from "src/assets/icon/cancel.svg";
import EditIcon from "assets/icon/edit.svg"
import moment from "moment";

let hasDatePopupOpen = false;
const initialValues = {
  coveredEntity: "",
  pharmacy: "",
  tpa: "",
};

const GeneralTab = ({ rowData, searchTerms, setConfigRules, data, setRowConfig, setClientCongigToggle, refetch  , selectedRowDynamic}) => {
  const API = useAxios();
  const [tableData1, setTableData] = useState(data);
  const [isdiable, setdiable] = useState(true);
  const [appdisable, setAppdisable] = useState(true);
  const [lookBackPeriod, setlookBackPeriod] = useState(data.lookBackPeriod);
  const [contractLive, setContractLive] = useState(false)
  const [state, updateState] = useState({
    initialValues: {
      checkLookBackPeriod: true,
      C2D: false,
      C3D: false,
      C4D: false,
      C5D: false,
      cashCardStatus: false,
      cashCardWindow: "",
      checkLookBackPeriod: true,
      contractLiveDate: true,
      DISP: 0,
      DCL: false,
      DEC: false,
      duplicateRxCheck: true,
      LBP: 0,
      OSD: "",
      otc: false,
      pharmacyStatus: true,
      profitRule: false,
      profitThreshold: "$ 0.00",
      reprocessing: false,
      reprocessingWindow: "",
      SIC: false,
      VDC: false,
      OGT: "",
      OGAT: "",
      OTC: false,
      NIOCD:0
    }
  });
  const formikRef = useRef();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const { initialValues } = state;
  const [loading, setLoading] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const [termDate, setTermDate] = useState(dateFormate(rowData.effectiveEndDate));


  //  let data1 = tableData?.find(i => i.contractID == searchTerms.contractID);

  useEffect(() => {
    if (data !== undefined && data.length > 0) {
      setdiable(false);
      let temp = state;
      for (var x in data) {
        var code = data[x].code;
        if (code === "OSD" || code === "DISP" ) {
          temp.initialValues[code] = data[x].defaultConfigValue;
        }
        else if (code === "LBP") {
          temp.initialValues[code] = parseInt(data[x].defaultConfigValue);
        }
        else if (code == "OGT") {
          var val = data[x].defaultConfigValue == "S" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else if (code == "OGAT") {
          var val = data[x].defaultConfigValue == "M" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else if (code === "NIOCD") {
          temp.initialValues[code] = parseInt(data[x].defaultConfigValue);
        }
        else {
          var val = data[x].defaultConfigValue == "Y" ? true : false;
          temp.initialValues[code] = val;
        }
      }
      setState(temp);
    }
    else
      setdiable(true);
    setTableData(data);


    //   setState({
    //     initialValues: {
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       c2DrugCheck:data.c2DrugCheck,
    //       c3DrugCheck:data.c3DrugCheck,
    //       c4DrugCheck:data.c4DrugCheck,
    //       c5DrugCheck:data.c5DrugCheck,
    //       cashCardStatus:data.cashCardStatus,
    //       cashCardWindow:data.cashCardWindow,
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       contractLiveDate:data.contractLiveDate,
    //       dispensingfeeCheck:data.dispensingfeeCheck,
    //       drugClassCheck:data.drugClassCheck,
    //       drugExclusionCheck:data.drugExclusionCheck,
    //       duplicateRxCheck:data.duplicateRxCheck,
    //       lookBackPeriod:data.lookBackPeriod,
    //       orderingStartDate:data.orderingStartDate,
    //       otc:data.otc,
    //       pharmacyStatus:data.pharmacyStatus,
    //       profitRule:data.profitRule,
    //       profitThreshold:"$ 0.00",
    //       reprocessing:data.reprocessing,
    //       reprocessingWindow:"",
    //       supplyCheck:data.supplyCheck,
    //       vaccineCheck:data.vaccineCheck,
    //       orderGenerationType:data.orderGenerationType
    //     }
    // });
  }, [data]);

  const lookBackPeriodOpt = [
    { lookBackPeriod: 30, label: "30 Days" },
    { lookBackPeriod: 60, label: "60 Days" },
    { lookBackPeriod: 90, label: "90 Days" },
    { lookBackPeriod: 120, label: "120 Days" },
  ];

  const reportOpt = [
    { id: 30, label: "30 Days" },
    { id: 60, label: "60 Days" },
    { id: 90, label: "90 Days" },
    { id: 120, label: "120 Days" },
  ];

  const orderGenerationOpt = [
    { id: 1, label: "Auto Generate/Replenishment" },
    { id: 2, label: "PO Split" },
  ];


  const autoGeneratedPOApprovalOPt = [
    { id: 1, label: "Always Auto Approve" },
    { id: 2, label: "Never Approve" },
  ];

  const NotInvoicedOrdersCancelDays = [
    { id:"", label: "--Select--"},
    { id: 15, label: "15 Days" },
    { id: 30, label: "30 Days" },
    { id: 60, label: "60 Days" },
    { id: 90, label: "90 Days" },
  ];
  const validationSchema = Yup.object({
    coveredEntity: Yup.string().required("Required"),
  });


  const handleSaveConfig = async () => {
    let frk = formikRef.current.values;
    var param = {};
    var arrData = [];
    var arr = {};
    // arr.code = "SIC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["SIC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "VDC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["VDC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "LBP";
    // arr.description = "";
    // arr.defaultConfigValue = frk["LBP"];
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C2D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C2D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C3D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C3D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C4D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C4D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C5D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C5D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DCL";
    // arr.description = "";
    // arr.defaultConfigValue = frk["DCL"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DEC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["DEC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "OTC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["OTC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DISP";
    // arr.description = "";
    // arr.defaultConfigValue = 0;
    // arrData.push(arr);

    arr = {};
    arr.code = "NIOCD";
    arr.description = "";
    arr.defaultConfigValue = frk["NIOCD"] == 0 ? null : frk["NIOCD"] ;
    arrData.push(arr);

    arr = {};
    arr.code = "OSD";
    arr.description = "";
    arr.defaultConfigValue = frk["OSD"];
    arrData.push(arr);

    arr = {};
    arr.code = "OGT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGT"] == "1" ? "A" : "S";
    arrData.push(arr);

    arr = {};
    arr.code = "OGAT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGAT"] == "1" ? "A" : "M";
    arrData.push(arr);

    param.JsonStr = arrData;

    try {
      const { data } = await API.post(`GWConfig/Configuration/SaveOrderContractConfig/${rowData.thirdPartyAdminID}/${rowData.ceid}/${rowData.phid}`, param, {
        hasDefaultURL: true,
      });
      if (data) {
        toast.success("Configurations saved successfully.");
        //  onHandleReset();
        handleReset();
      } else {
        toast.error("An error occurred");
        //setData([]);
        //setTotalItem(0);
      }
    } catch (error) { }
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };





  const handelClickimage = () => {
    setRowConfig(true);
    setClientCongigToggle(false);
    setConfigRules(false)
  };


  const termDateSubmit = async () => {
    let payload = {}
    payload.EffectiveEndDate = termDate;
    payload.contractID = rowData.contractID;
   
    try {
     //  setLoading(true);
      const data = await API.post(
        `GWConfig/Configuration/updateContractTermDate`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data.data == true) {
        refetch();
        toast.success("Contract Term Date saved successfully");
        setUpdateClicked(false)
         //setLoading(false);

      } else {
      }
    } catch (err) {
    }
  };

  const handleEditButton = () => {
    setUpdateClicked(true)
  }


  const CancelButton = () => {
    return (
      <Button color='primary' className='reset' hidden={!updateClicked} disabled={!updateClicked} size='sm' onClick={() => {
        setTermDate( dateFormate(selectedRowDynamic.effectiveEndDate)) ;
        setUpdateClicked(false)
      }}>
        <span className="right_5">
          <img src={Cancel} alt="" />{" "}
           Cancel
        </span>
      </Button>
    )
  }


  const SubmitButton = () => {

    return (
      <Button color='primary' className='search' hidden={!updateClicked} disabled={!updateClicked} size='sm' onClick={termDateSubmit}>
        <span className="right_5">
          <img src={save} alt=""  />{" "}
           Save
        </span>

      </Button>

    )
  }

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleReset = () => {
    setState({
      initialValues: {
        checkLookBackPeriod: true,
        C2D: false,
        C3D: false,
        C4D: false,
        C5D: false,
        cashCardStatus: false,
        cashCardWindow: "",
        checkLookBackPeriod: true,
        contractLiveDate: true,
        DISP: 0,
        DCL: false,
        DEC: false,
        duplicateRxCheck: true,
        LBP: 0,
        OSD: "",
        otc: false,
        pharmacyStatus: true,
        profitRule: false,
        profitThreshold: "$ 0.00",
        reprocessing: false,
        reprocessingWindow: "",
        SIC: false,
        VDC: false,
        OGT: "",
        OGAT: "",
        NIOCD: 0,
      }
    });
  }

  const handleChange = event => {
    setMessage(event.target.value);
  };

  const handleSwitchChange = (e, val) => {
    let frk = formikRef.current.values;
    if (val == "NIOCD") {
      const inputValue = e.target.value;
      const numericValue = parseInt(inputValue, 10);
      if (numericValue >= 1 && numericValue <= 365) {
        frk[val] = e.target.value;
      } else {
        frk[val] = "";
      }
    }
    if (val == "LBP" || val == "OGT" || val == "OGAT") {
      frk[val] = e.target.value;
    }
    else if (val == "OSD") {
      frk[val] = dateFormate(e);
    }
    // else {
    //   frk[val] = e.target.checked;
    // }
    setState({
      initialValues: frk
    });
  }

  const handleEndDate = (endDate) => {
    setTermDate(moment(new Date(endDate)).format(
      "MM/DD/YYYY"))
  };


  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      innerRef={formikRef}
      children={(props) => {
        // const { isSubmitting, handleSubmit } = props;
        return (
          <div>
            <Row>


              <Col md="2" >
                <FormGroup switch>
                  <Input
                    type="switch"
                    id="pharmacyStatus"
                    name="pharmacyStatus"
                    checked={data.pharmacyStatus}
                    disabled={appdisable}
                  />
                  <Label check className="toggle-label">Contract Status</Label>
                </FormGroup>
              </Col>

              <Col md="6">
                <p className="mt-2 f-14 font-weight-500 " style={{marginBottom:"4px" }}>Contract Term Date</p>
                {/* <p className="mt-2 f-14 font-weight-500 font-weight-500 mt-1"> */}


                <Formik>
                  <FormGroup>
                    <InputGroup onMouseLeave={handleMouseLeave} style={{ width: "45%" }}>
                      <Field
                        type="text"
                        id="endDate"
                        name="endDate"
                        autoComplete="off"
                        placeholder="Select a date"
                        disabled = {!updateClicked}
                        value={termDate}
                        minDate = {moment.utc().startOf('day').toDate()} 
                        show={true}
                        component={FormikDatePicker}
                        onChange={(e) => handleEndDate(e)}
                      />
                      <InputGroupText
                        onClick={() => handleDateClick("endDate")}
                      >
                        <img src={Calendar} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Formik>



              </Col>


              <Col md="4" style={{ textAlignLast: "end" }}>

                <Button
                  color="primary"
                  className="search"
                  onClick={handleEditButton}
                  hidden={updateClicked}
                >
                  <span className="right_5">
                    <img src={Addicon} alt=""
                    />
                  </span>{" "}
                  Edit
                </Button>



              </Col>

            </Row>

            <Row className="d-flex justify-content-end row" style={{}}>
              <Col md="auto" className="mt-1" >
                <SubmitButton />
                <CancelButton />
              </Col>


            </Row>

          </div>
        );
      }}
    ></Formik>
  );
};
export default GeneralTab;
